export default "__VITE_ASSET__C$GfeF6P__"